import type { ProductUnitCategory } from '../enums/productUnitCategory'
import type { ProductUnit } from '../types/productUnit'
import { getProductUnitCategory } from './getProductUnitCategory'

interface ProductUnitsGroup<T extends ProductUnit> {
  category: ProductUnitCategory
  units: T[]
}

export const groupProductUnitsByCategory = <T extends ProductUnit>(
  units: T[],
  categories: ProductUnitCategory[],
): ProductUnitsGroup<T>[] =>
  categories
    .map((category) => ({ category, units: units.filter((unit) => getProductUnitCategory(unit) === category) }))
    .filter((group) => group.units.length)
